import { useEffect, useState } from "react";
import api from "@/lib/api";
import { cachedGet } from "@/lib/offlineCache";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const OTHER = "__other__";

// Generische Auswahl aus einer Stammdatenliste (component_option_lists).
// Optional gefiltert nach Gruppe (z. B. Modelle je Hersteller, Federcodes je Seite L/R)
// + "Sonstiges …" für Freitext. Wert bleibt ein einfacher String (Label).
export function CatalogSelect({ listKey, value, onChange, filterGruppe, placeholder = "Auswählen …", testid = "catalog-select" }) {
  const [items, setItems] = useState([]);
  const [other, setOther] = useState(false);

  useEffect(() => {
    cachedGet("/v1/catalogs/component-option-lists")
      .then((d) => { const l = (d || []).find((x) => x.key === listKey); setItems(l?.items || []); })
      .catch(() => setItems([]));
  }, [listKey]);

  const norm = (s) => (s || "").toString().trim().toLowerCase();
  const opts = filterGruppe ? items.filter((i) => norm(i.gruppe) === norm(filterGruppe)) : items;
  const labels = opts.map((o) => o.label);
  useEffect(() => { setOther(!!value && !labels.includes(value)); }, [value, items, filterGruppe]); // eslint-disable-line react-hooks/exhaustive-deps

  const selectValue = other ? OTHER : (labels.includes(value) ? value : "");

  return (
    <>
      <Select value={selectValue} onValueChange={(v) => {
        if (v === OTHER) { setOther(true); onChange(""); }
        else { setOther(false); onChange(v); }
      }}>
        <SelectTrigger data-testid={testid}><SelectValue placeholder={placeholder} /></SelectTrigger>
        <SelectContent>
          {opts.map((o) => <SelectItem key={o.key} value={o.label}>{o.label}</SelectItem>)}
          <SelectItem value={OTHER}>Sonstiges …</SelectItem>
        </SelectContent>
      </Select>
      {other && (
        <Input className="mt-1.5" placeholder="Frei eingeben" data-testid={`${testid}-other`}
          value={value || ""} onChange={(e) => onChange(e.target.value)} />
      )}
    </>
  );
}
